<template>
	<div class="homePage-project-yijian">
		<el-row>
			<el-col class="en">
				ALREADY BUILT PROJECTS
			</el-col>
			<el-col class="ch">
				<img src="/img/yijian.png" draggable="false" />
			</el-col>
			<el-col>
				<div class="projectList">
					<div v-for="item in pList" class="project" @click="openProject(item)">
						<img :src="'/file/project/yijian/'+item.id+'/icon.png'" draggable="false"></img>
						<div class="name">{{item.name}}</div>
						<div class="viewCount"><i class="el-icon-view"></i> {{item.viewCount}}</div>
					</div>
				</div>
			</el-col>
			<el-col>
				<el-button type="text" class="more" @click="goProject('yijian')">MORE <i class="el-icon-right"></i> </el-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import projectList from '@/assets/project.js'

	export default {
		data() {
			return {
				pList: []
			}
		},
		created() {
			this.pList = projectList.yijian.slice(0, 6)
		},
		methods: {
			goProject(val) {
				this.$emit('setDefaultactive', 'project')
				this.$router.push({
					path: 'project',
					query: {
						name: val
					}
				})
			},
			openProject(val) {
				this.$emit('setDefaultactive', 'project')

				this.$router.push({
					path: 'project',
					query: {
						name: 'yijian',
						id: val.id
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.homePage-project-yijian {
		height: 720px;
		background-image: url('/img/已建项目背景.png');
		background-repeat: no-repeat;
		text-align: center;

		.en {
			font-size: 36px;
			color: #fff;
			margin-bottom: 10px;
			margin-top: 20px;
		}

		.ch {
			color: #fff;
			font-size: 20px;
			margin-bottom: 10px;
		}

		.projectList {
			width: 1440px;
			margin: 0px auto;

			.project {
				margin: 20px 32px;
				width: 415px;
				height: 235px;
				float: left;
				color: #fff;
				cursor: pointer;

				img {
					border-radius: 8px;
					width: 415px;
					height: 235px;
				}

				.name {
					background: -webkit-linear-gradient(top, #87878711, #35353566, #00000066);
					opacity: 0.99;
					font-size: 16px;
					text-align: left;
					height: 60px;
					line-height: 70px;
					margin-top: -63px;
					padding-left: 10px;
					border-bottom-right-radius: 8px;
					border-bottom-left-radius: 8px;
				}


				.viewCount {
					opacity: 0.99;
					height: 60px;
					line-height: 70px;
					margin-top: -60px;
					margin-right: 10px;
					text-align: right;

					i {
						font-weight: bold;
					}
				}
			}
		}

		.more {
			color: #fff;
		}
	}
</style>